module.exports = __webpack_public_path__ + "img/l.df0d5cd4.jpg";